import React from 'react'
import { useIntl } from 'react-intl'
import { isAmountAttribute, isCaffeineAttribute } from './Filters.utils'
import * as T from '@/pages/product-list/ProductList.types'

export const FilterLabel = ({
  attributeID,
  label,
  isSelected = false
}: T.FilterLabelProps) => {
  const { formatMessage } = useIntl()
  const withCaffeineMessage = formatMessage({
    defaultMessage: 'with caffeine',
    id: 'msp.refinements.with-caffeine'
  })
  const withoutCaffeineMessage = formatMessage({
    defaultMessage: 'without caffeine',
    id: 'msp.refinements.without-caffeine'
  })

  if (isAmountAttribute(attributeID) && !isSelected) {
    return <></>
  }

  if (isCaffeineAttribute(attributeID)) {
    if (label === 'true') {
      return <>{withCaffeineMessage}</>
    }

    if (label === 'false') {
      return <>{withoutCaffeineMessage}</>
    }
  }

  return <>{label}</>
}
